<template>
  <button
    type="button"
    class="cursor-pointer text-secondary inline-flex items-center gap-2 hover:opacity-80"
    @click="onShare"
  >
    <ShareIcon class="w-5 h-5" aria-hidden="true" />
    <span v-if="copied" aria-live="polite">Copied!</span>
    <span v-else>{{ label ?? 'Share' }}</span>
  </button>
</template>

<script setup lang="ts">
import { useClipboard } from '@vueuse/core'
import { toRefs } from 'vue'

import ShareIcon from '@/assets/share.svg?component'

const props = defineProps<{
  url: string
  title?: string
  text?: string
  label?: string
}>()

const { url } = toRefs(props)
const { copy, copied } = useClipboard({ source: url })

interface ShareDataButton {
  url: string
  title?: string
  text?: string
}

async function onShare(): Promise<void> {
  const data: ShareDataButton = { url: props.url }
  if (props.title) data.title = props.title
  if (props.text) data.text = props.text
  if (typeof navigator !== 'undefined' && navigator.share && (navigator.canShare?.(data) ?? true)) {
    try {
      await navigator.share(data)
      return
    } catch (err) {
      if (err instanceof Error && err.name === 'AbortError') return
    }
  }
  await copy()
}
</script>
